"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const checkIfWicketCreditedToBowler = (dismissalId) => {
    return dismissalId > 1 && dismissalId != 6 && dismissalId < 8;
};
exports.default = checkIfWicketCreditedToBowler;
//# sourceMappingURL=checkIfWicketCreditedToBowler.js.map